import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityOrderTemplateEditForm } from "application/facility-order/forms";
import { LookupService } from "common/services";
import { BranchService } from 'application/facility/services';
import { FacilityOrderTemplateService, FacilityOrderTemplateNoteService, FacilityOrderTemplateItemService, ItemSubcategoryService } from "application/facility-order/services";
import { ImportReferenceService } from 'application/import-reference/services';
import { MissingDocumentService } from 'application/missing-document/services';
import { DiagnosisCodeService } from "application/import/services";
import { action, observable, runInAction, reaction } from "mobx";
import { inactiveReasons } from 'core/constants';
import { ModalParams } from 'core/models';
import {
	PROCEDURE_CODE_B4035,
	PROCEDURE_CODE_B4036
} from "core/constants"
import _ from 'lodash';

class FacilityOrderTemplateItemEditViewStore extends BaseEditViewStore {
	@observable accessor facilityOrderTemplateItems = [];
	@observable accessor facilityOrderTemplateValidations = [];
	@observable accessor facilityOrderTemplateNotes = [];
	@observable accessor isNotFoundImportReference = false;
	@observable accessor productStore = null;
	@observable accessor primaryInsuranceInfo = null;
	@observable accessor isMatchReference = false;
	@observable accessor isImportDetailStatusImported = false;
	@observable accessor isImportDetailStatusFaild = false;
	@observable accessor isReadOnly = false;
	@observable accessor isQtyReadOnly = false;
	@observable accessor lastValidated = 0;
	@observable accessor isDirty = false;
	@observable accessor isMissingDocument = false;
	@observable accessor validationMessage = null;
	@observable accessor facilityOrderTemplate = null;
	@observable accessor isReloadTemplateEnabled = false;
	@observable accessor showMessage = false;
	@observable accessor message = null;
	@observable accessor isNoneInactiveReason = null;
	@observable accessor isSecondaryInsuranceVerified = false;
    @observable accessor isExistDxCode1 = true;
    @observable accessor isExistDxCode2 = true;
    @observable accessor isExistDxCode3 = true;
    @observable accessor isExistDxCode4 = true;
	@observable accessor isExistDxCode5 = true;
    @observable accessor isExistDxCode6 = true;
    @observable accessor isExistDxCode7 = true;
    @observable accessor isExistDxCode8 = true;

	constructor(rootStore, componentsProps) {
        const branchService = new BranchService(rootStore.application.baasic.apiClient);
        const missingDocumentService = new MissingDocumentService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        const service = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			name: "facility-order-template-item-edit" + componentsProps.id,
			id: componentsProps.id,
			Form: FacilityOrderTemplateEditForm,
			authorization: 'portalSection.update',
			actions: {
				get: async (id, opts) => {
					const response = await service.get(id, {
						...opts,
						embed: "FacilityOrder,FacilityOrderTemplateItems,ItemCategory,ImportReference,TrackingCase,SubCategory,FacilityOrderTemplateValidations,FacilityOrderTemplateNotes,FacilityOrderTemplateMissingDocuments,ImportDetailStatus"
					});
					this.facilityOrderTemplate = response.data;
					this.isNoneInactiveReason = !response.data.inactiveReason || response.data.inactiveReason === "None";
					response.data.facilityOrderTemplateMissingDocuments = response.data.facilityOrderTemplateMissingDocuments && response.data.facilityOrderTemplateMissingDocuments.map(i => ({ ...i.missingDocument, facilityOrderTemplateMissingDocumentId: i.id, note: i.note }));
					this.form.update(response.data);
					await this.getLookups();

					this.dxCode1Store = this.createDxCodeDropdownStore("dxCode1", "isExistDxCode1");
					this.dxCode2Store = this.createDxCodeDropdownStore("dxCode2", "isExistDxCode2");
					this.dxCode3Store = this.createDxCodeDropdownStore("dxCode3", "isExistDxCode3");
					this.dxCode4Store = this.createDxCodeDropdownStore("dxCode4", "isExistDxCode4");
					this.dxCode5Store = this.createDxCodeDropdownStore("dxCode5", "isExistDxCode5");
					this.dxCode6Store = this.createDxCodeDropdownStore("dxCode6", "isExistDxCode6");
					this.dxCode7Store = this.createDxCodeDropdownStore("dxCode7", "isExistDxCode7");
					this.dxCode8Store = this.createDxCodeDropdownStore("dxCode8", "isExistDxCode8");

					await this.getEnteralItemCategories();
					await this.getWoundCareItemCategories();
					await this.getTrachItemCategories();

					this.referenceStore.setValue(response.data.importReference);
					if (response.data && response.data.importDetailStatus) {
						this.isImportDetailStatusImported = response.data.importDetailStatus.abrv === 'imported';
						this.isImportDetailStatusFaild = response.data.importDetailStatus.abrv === 'failed';
						this.isReadOnly = this.isImportDetailStatusImported || this.isImportDetailStatusFaild;
					}
					if (response.data && response.data.importReference && (response.data.importReference.isBillableToMedicare || (response.data.importReference.importReferenceType && response.data.importReference.importReferenceType.name === "Missing Documents")) && this.isNoneInactiveReason) {
						this.isSecondaryInsuranceVerified = true;
					}

					this.checkIsReloadTemplateEnabled(response.data);

					if (response.data && response.data.importReference && ((response.data.importReference.importReferenceType && response.data.importReference.importReferenceType.name === "Missing Documents") || response.data.importReference.isBillableToMedicare)) {
						await this.missingDocumentStore.filterAsync();
						this.form.$("facilityOrderTemplateMissingDocuments").set('disabled', false);
						this.isMissingDocument = true;
					}
					else {
						this.missingDocumentStore.filterAsync();
						this.form.$("facilityOrderTemplateMissingDocuments").value = "";
						this.missingDocumentStore.setValue([]);
						this.form.$("facilityOrderTemplateMissingDocuments").set('disabled', true);
						this.isMissingDocument = false;
					}
					this.isNotFoundImportReference = response.data.importReference && response.data.importReference.abrv === 'not-found' ? true : false;
					var insuranceInfo = response.data.importReference && response.data.importReference.insurance ? response.data.importReference.insurance.name : '';
					this.primaryInsuranceInfo = componentsProps.insuranceInfo && componentsProps.insuranceInfo.payorPolicyInfo ? componentsProps.insuranceInfo.payorPolicyInfo.name : '';
					
					if (this.primaryInsuranceInfo === '' && insuranceInfo === '') {
						this.isMatchReference = true;
					}
					else {
						this.isMatchReference = this.primaryInsuranceInfo == insuranceInfo;
					}
					this.checkMatchReference(insuranceInfo, this.facilityOrderTemplate.importReference && this.facilityOrderTemplate.importReference.isBillableToMedicare === true);
					const mappedData = response.data && this.cloneObjectAndAttachProps(response.data, {
						inactiveReasonId: response.data.inactiveReasonId !== null ? response.data.inactiveReasonId.toString() : "",
						changed: false
					});
					this.facilityOrderTemplateValidations = response.data.facilityOrderTemplateValidations;

					this.isMasterPatient = this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrder && this.facilityOrderTemplate.facilityOrder.facility && this.facilityOrderTemplate.facilityOrder.facility.masterPatientId == this.patientKey;

					return mappedData;
				},
				// update: async resource => {
				//  let item = this.item;
				//  item.facilityOrderTemplateItems = this.item.facilityOrderTemplateItems.filter(i => i.id && !i.id.includes('new'));
				//  resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i=> { return { missingDocumentId: i.id }});
				//  const response = await service.update({
				//      ...item,
				//      ...resource
				//  });
				//  this.validationMessage = response.data.message;
				//  return response.data;
				// },
				updateTemplateAndItems: async resource => {
					let item = this.item;
					item.facilityOrderTemplateItems = this.facilityOrderTemplateItems.filter(x => !x.id.startsWith('new'));
					resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id, note: i.note } });
					const response = await service.updateTemplateAndItems({
						...item,
						...resource
					});
					item.isReviewed = response.data.isReviewed;
					item.facilityOrderTemplateItems.forEach(i => {
						let item = response.data.facilityOrderTemplateItems ? response.data.facilityOrderTemplateItems.find(x => x.id === i.id) : false;
						i.changed = false;
						i.billingQuantity = item ? item.billingQuantity : i.billingQuantity;
						i.templateBillingQuantity = item ? item.templateBillingQuantity : i.templateBillingQuantity;
						i.procedureCode = item ? item.procedureCode : i.procedureCode;
						i.importActionId = item ? item.importActionId : i.importActionId;
						i.importAction = item ? item.importAction : i.importAction;
					});

					this.setFacilityOrderTemplateMissingDocumentId(response.data.facilityOrderTemplateMissingDocuments);

					this.facilityOrderTemplateValidations = response.data.facilityOrderTemplateValidations;
					this.validationMessage = response.data.message;

					return response.data;
				},
				batchCreateItems: async () => {
					let facilityOrderTemplateItems = this.facilityOrderTemplateItems.filter(x =>
						x.id.startsWith('new') && x.productId !== null)
						.map(i => ({ ...i }));

					facilityOrderTemplateItems.forEach(i => delete i.id);
					var responseMessage = '';
					if (facilityOrderTemplateItems.length > 0) {
						if (this.isNewTemplate()) {
							try {
								let response = await facilityOrderTemplateItemService.createAdditionalItems(facilityOrderTemplateItems);
								this.facilityOrderTemplateItems = this.facilityOrderTemplateItems.filter(i => i.id && !i.id.includes('new'));
								this.facilityOrderTemplateItems.push(...response);

								if (response[0].product && response[0].product.innerCannulaId && response[0].product.subCategory
									&& this.trachItemCategoriesId === response[0].product.subCategory.itemCategoryId) {
									this.refreshTemplates(this.facilityOrderId, this.patientId);
								}
								this.item.facilityOrderTemplateItems = this.facilityOrderTemplateItems;
								responseMessage = await service.validateItems(this.id, { embed: "FacilityOrderTemplateItems" });
								this.validationMessage = responseMessage.data;
								return response.data;
							}
							catch (err) {
								if (err.data) {
									return this.rootStore.notificationStore.error(err.data);
								}
								else {
									rootStore.notificationStore.error('FACILITY_ORDER.CREATE.ERROR');
								}
							}
						}
						else {
							let response = await facilityOrderTemplateItemService.batchCreate(facilityOrderTemplateItems);
							this.facilityOrderTemplateItems = this.facilityOrderTemplateItems.filter(i => i.id && !i.id.includes('new'));
							this.facilityOrderTemplateItems.push(...response.data);
							responseMessage = await service.validateItems(this.id, { embed: "FacilityOrderTemplateItems" });
							this.validationMessage = responseMessage.data;
							return response.data;
						}
					}

					return null;
				}//,
				// batchUpdateItems: async () => {
				//  const facilityOrderTemplateItems = this.facilityOrderTemplateItems.filter(x => !x.id.startsWith('new') && x.changed === true);

				//  if(facilityOrderTemplateItems.length > 0){
				//      const response = await facilityOrderTemplateItemService.batchUpdate(facilityOrderTemplateItems);

				//      facilityOrderTemplateItems.forEach(i => {
				//          i.changed = false;
				//      });

				//      return response.data;
				//  }

				//  return null;
				// }
			},
			errorActions: {
				onCreateError: ({ error }) => {
					rootStore.notificationStore.error('FACILITY_ORDER.CREATE.ERROR', error);
				},
				onUpdateError: ({ error }) => {
					rootStore.notificationStore.error('FACILITY_ORDER.EDIT.ERROR', error);
				},
			},
			FormClass: FacilityOrderTemplateEditForm,

		});

        this.service = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.importReferenceService = new ImportReferenceService(rootStore.application.baasic.apiClient);
        this.refreshTemplates = componentsProps.refreshTemplates;
        this.removeFromFacilityOrderTemplateList = componentsProps.removeFromFacilityOrderTemplateList;
        this.isReadyForImportFacilityOrder = componentsProps.isReadyForImportFacilityOrder;
        this.facilityOrderId = rootStore.routerStore.routerState.params.facilityOrderId;
        this.patientId = rootStore.routerStore.routerState.params.patientId;
        this.patientKey = rootStore.routerStore.routerState.params.patientKey;
        this.diagnosisCodeService = new DiagnosisCodeService(rootStore.application.baasic.apiClient);
        this.saveAllTemplates = componentsProps.saveAllTemplates;
        this.btPatient = componentsProps.btPatient;
        this.facilityInventoryCalculation = componentsProps.facilityInventoryCalculation;

        this.referenceStore = new BaasicDropdownStore({
			filterable: true,
			returnObject: true
		}, {
			fetchFunc: async (term) => {
				const response = await this.importReferenceService.find({ searchQuery: term, rpp: 100, isActive: true, sort: "name|asc", embed: "Insurance,ImportReferenceType" });
				if (response.data.item && response.data.item.importReferenceType && response.data.item.importReferenceType.name == "Missing Documents")
					this.form.$("facilityOrderTemplateMissingDocuments").set('disabled', true);
				return response.data.item;
			},
			onChange: async (item) => {
				this.setProductStore();

				if (item && ((item.importReferenceType && item.importReferenceType.name === "Missing Documents") || item.isBillableToMedicare)) {
					this.form.$("facilityOrderTemplateMissingDocuments").set('disabled', false);
					this.isMissingDocument = true;
				}
				else {
					this.missingDocumentStore.filterAsync();
					this.form.$("facilityOrderTemplateMissingDocuments").value = "";
					this.missingDocumentStore.setValue([]);
					this.form.$("facilityOrderTemplateMissingDocuments").set('disabled', true);
					this.isMissingDocument = false;
				}
				await this.updateTemplateAndItemsResource(this.form.values());
				this.form.$("importReferenceId").resetValidation();

				if (item && (item.isBillableToMedicare || (item.importReferenceType && item.importReferenceType.name === "Missing Documents")) && (!item.inactiveReason || item.inactiveReason === "None")) {
					this.isSecondaryInsuranceVerified = true;
				} else {
					this.isSecondaryInsuranceVerified = false;
				}
			}
		});

        this.inactiveReasonStore = new BaasicDropdownStore({}, {
			onChange: async (term) => {
				await this.updateTemplateAndItemsResource(this.form.values());
				const noneInactiveReason = inactiveReasons.find(reason => reason.name === "None");
				const noneInactiveReasonId = noneInactiveReason ? noneInactiveReason.id : null;
				
				if (term === noneInactiveReasonId) {
					this.isNoneInactiveReason = true;
					this.isSecondaryInsuranceVerified = this.isTemplateBillableToMedicare();
				} else {
					this.isSecondaryInsuranceVerified = false;
					this.isNoneInactiveReason = false;
				}
			}
		});
        this.inactiveReasonStore.setItems(inactiveReasons);

        this.branchStore = new BaasicDropdownStore({}, {
			fetchFunc: async (term) => {
				const response = await branchService.find({ searchQuery: term, rpp: 100, isActive: true, sort: 'name|asc' });
				return response.data.item;
			},
		});

        this.missingDocumentStore = new BaasicDropdownStore({ multi: true, filterable: true, initFetch: false }, {
			fetchFunc: async (term) => {
				const response = await missingDocumentService.find({ searchQuery: term, rpp: 100, isActive: true, sort: 'name|asc', itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.subCategory.itemCategoryId });
				return this.filterMissingDocumentStore(response.data.item);
			}
		});

        this.facilityOrderTemplateAddNoteModal = new ModalParams({ onClose: null });
        this.facilityOrderTemplateValidationModal = new ModalParams({ onClose: null });
        this.facilityOrderTemplateMissingDocumentNoteModal = new ModalParams({ onClose: null });
        this.facilityOrderTemplatePNMissingInformationModal = new ModalParams({ onClose: null });

        this.timer = null;
        reaction(
			() => this.itemInitialized,
			() => {
				if (this.itemInitialized) {
					setTimeout(() =>
						this.form.fields._keys.forEach(k => this.form.observe({
							path: k,
							key: 'value',
							call: () => {
								this.setTemplateTimer();
							}
						})))
				}
			}
		);
        reaction(
			() => this.isDirty,
			() => {
				if (this.isDirty) {
					this.setTemplateTimer();
				}
			}
		);
    }

	filterMissingDocumentStore(missingDocuments) {
		let result = missingDocuments;
		if(missingDocuments && missingDocuments.some(m => m)){
			let facilityOrderTemplateItems = this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems;
			if(this.facilityOrderTemplateItems && this.facilityOrderTemplateItems.some(i => i)){
				facilityOrderTemplateItems = this.facilityOrderTemplateItems;
			}

			const deleteImportActionId = this.importActions.find(x => x.abrv === 'delete').id;

			const diabeticFormulaSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "diabetic-formula").id;
			const renalFormulaNeproNRSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "renal-formula-nepro-nr").id;
			const renalFormulaSuplenaSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "renal-formula-suplena").id;
			const pulmonaryFormulaSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "pulmonary-formula").id;
			const elementalFormulaSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "elemental-formula").id;
			const proteinSupplementSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "protein-supplement").id;
			const siliconeCatheterSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "silicone-catheter").id;
			const coudeCatheterSpecialtyTypeId = this.specialtyTypes.find(x => x.abrv === "coude-catheter").id;

			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == diabeticFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-diabetic");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaNeproNRSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-renal-nepro");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaSuplenaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-renal-suplena");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == pulmonaryFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-pulmonary");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == elementalFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-elemental");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == proteinSupplementSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-protein-supplement");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == siliconeCatheterSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-silicone-catheter");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == coudeCatheterSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-coude-catheter");
			}
		}
		return result;
	}

	@action.bound
	createDxCodeDropdownStore(propertyName, isExsistDxCode) {
        return new BaasicDropdownStore(
            { filterable: true, dataItemKey: "code", textField: "code" },
            {
                fetchFunc: async (term = this.facilityOrderTemplate[propertyName]) => {
                    if(!term || term.trim() === '') {
                        term = undefined;
                    }
                    const response = await this.diagnosisCodeService.find({ searchQuery: term, rpp: 10, itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.itemCategoryId, isBillable: true });
                    return response.data.item;
                },
				onChange: async () => {
                    await this.isExsistDxCode(propertyName, isExsistDxCode);
                }
            }
        );
    }

	@action.bound
	async isExsistDxCode(propertyName, isExistDxCode) {
		if (this.form.$(propertyName).value === null || this.form.$(propertyName).value === "") {
            this[isExistDxCode] = true;
			return;
        }

        var diagnosisCode = await this.diagnosisCodeService.getExisting(this.form.$(propertyName).value);
        if (diagnosisCode && diagnosisCode.item && diagnosisCode.item[0]){
			this[isExistDxCode] = diagnosisCode.item[0].isBillable;
			return;
		}
		this[isExistDxCode] = true;
    }

	@action.bound
	setTemplateTimer() {
		if (this.itemInitialized || this.isDirty) {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => this.form.submit(), 60000);
		}
	}

	@action
	async setItem(item) {
		this.item = item;
		this.itemInitialized = true;
		this.facilityOrderTemplateItems = item.facilityOrderTemplateItems;
		this.facilityOrderTemplateValidations = item.facilityOrderTemplateValidations;
		this.facilityOrderTemplateNotes = item.facilityOrderTemplateNotes;

		this.facilityOrderTemplateNotes = _.sortBy(this.facilityOrderTemplateNotes, [
			function (o) {
				return o.dateCreated;
			},
		]);

		this.templateItemsRowRefs = [];
		if (this.facilityOrderTemplateItems.length === 0) {
			this.addItem();
		}

		await this.setDefaultStoreValue(item);
	}

    @action.bound
    async setDefaultStoreValue(data) {
        this.dxCode1Store.setValue(data.dxCode1 && { code: data.dxCode1});
        this.dxCode2Store.setValue(data.dxCode2 && { code: data.dxCode2});
        this.dxCode3Store.setValue(data.dxCode3 && { code: data.dxCode3});
        this.dxCode4Store.setValue(data.dxCode4 && { code: data.dxCode4});
        this.dxCode5Store.setValue(data.dxCode5 && { code: data.dxCode5});
        this.dxCode6Store.setValue(data.dxCode6 && { code: data.dxCode6});
        this.dxCode7Store.setValue(data.dxCode7 && { code: data.dxCode7});
        this.dxCode8Store.setValue(data.dxCode8 && { code: data.dxCode8});
		await this.isExsistDxCode("dxCode1", "isExistDxCode1");
		await this.isExsistDxCode("dxCode2", "isExistDxCode2");
		await this.isExsistDxCode("dxCode3", "isExistDxCode3");
		await this.isExsistDxCode("dxCode4", "isExistDxCode4");
		await this.isExsistDxCode("dxCode5", "isExistDxCode5");
		await this.isExsistDxCode("dxCode6", "isExistDxCode6");
		await this.isExsistDxCode("dxCode7", "isExistDxCode7");
		await this.isExsistDxCode("dxCode8", "isExistDxCode8");
    }

	@action.bound
	async getEnteralItemCategories() {
		let itemCategory = this.itemCategories.filter(i => i.abrv.includes("enteral"));
		this.enteralItemCategories = _.orderBy(itemCategory, ['name'], ['asc']);
	}

	@action.bound
	async getWoundCareItemCategories() {
		this.woundCareItemCategories = this.itemCategories.filter(i => i.abrv === "wound-care");
	}

	@action.bound
	async getTrachItemCategories() {
		this.trachItemCategoriesId = this.itemCategories.find(i => i.abrv === 'respiratory').id;
		this.trachTubeSubCategoryId = this.subCategories.find(i => i.abrv === 'Trach-Tube').id;
	}

	async getLookups() {
		const response = await this.lookupService.getLookups("ImportAction,SpecialtyType,ImportDetailStatus,ItemType,UnitOfMeasure,SubCategory,ImportReferenceType,ItemCategory");
		runInAction(() => {
			this.importActions = response.importAction;
			this.specialtyTypes = response.specialtyType;
			this.importDetailStatuses = response.importDetailStatus;
			this.itemTypes = response.itemType;
			this.unitOfMeasures = response.unitOfMeasure;
			this.subCategories = response.subCategory;
			this.itemCategories = response.itemCategory;
			this.importReferenceTypes = response.importReferenceType;
		})

	}

	setProductStore() {
		let unitOfMeasure = null;
		const subCategory = this.subCategories.find(x => x.abrv == 'Enteral---Supplies');
		const ostomySubCategory = this.subCategories.find(x => x.abrv == 'Ostomy-Products');
		if (!(this.referenceStore.value && this.referenceStore.value.abrv === "Extra-Supplies" && this.isMasterPatient)) {
			if ((subCategory && subCategory.id && subCategory.id !== this.item.subCategoryId) ||
				(this.referenceStore.value && (this.referenceStore.value.abrv === "Extra-Supplies" || this.referenceStore.value.abrv === "Extra-Supplies-House-stock"))) {
				unitOfMeasure = this.unitOfMeasures.find(x => x.abrv == 'CA');
			}
		}

		this.productStore = new BaasicDropdownStore({
			filterable: true,
			textField: "itemId",
		}, {
			fetchFunc: async (term) => {
				let params = {
					searchQuery: term,
					rpp: 50,
					subCategoryId: this.item.subCategoryId,
					isActive: true,
					unitOfMeasureIdToExclude: unitOfMeasure && unitOfMeasure.id,
					embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_"
				}

				if (this.item.subCategoryId == ostomySubCategory.id) {
					params = { ...params, sort: "isPreferred|desc" };
				}

				const response = await this.itemSubcategoryService.find(params);

				let filteredProducts = _.map(response.data.item, item => {
					return {
						...item.product
					};
				});

				return filteredProducts
			}
		});
	}

	@action.bound
	openFacilityOrderTemplateAddNoteModal(facilityOrderTemplateId, facilityOrderTemplateNoteId, note, isActive) {
		this.facilityOrderTemplateAddNoteModal.open({
			facilityOrderTemplateId: facilityOrderTemplateId,
			facilityOrderTemplateNoteId: facilityOrderTemplateNoteId,
			note: note,
			isActive: isActive,
			facilityOrderTemplateAddNote: this.facilityOrderTemplateAddNote,
			facilityOrderTemplateUpdateNote: this.facilityOrderTemplateUpdateNote,
		});
	}

	@action.bound
	async openFacilityOrderTemplateValidationModal() {
		this.facilityOrderTemplateValidationModal.open({
			facilityOrderTemplateId: this.facilityOrderTemplate.id,
			getTemplate: () => this.actions.get(this.id)
		});
	}

	@action.bound
	openFacilityOrderTemplateMissingDocumentNoteModal(missingDocument) {
		this.facilityOrderTemplateMissingDocumentNoteModal.open({
			missingDocument: missingDocument
		});
	}

	@action.bound
	facilityOrderTemplateAddNote(response) {
		this.facilityOrderTemplateNotes.push(response);
	}

	@action.bound
	facilityOrderTemplateUpdateNote(id, note) {
		this.facilityOrderTemplateNotes.find(x => x.id === id).note = note;
	}

	@action.bound
	editMissingDocumentNote(missingDocument) {
		this.openFacilityOrderTemplateMissingDocumentNoteModal(_.extend(missingDocument, { facilityOrderTemplateId: this.facilityOrderTemplate.id }));
	}

	@action.bound
	editItem(index, value, propertyName) {
		this.isDirty = true;

		if(propertyName == "mlph"  || propertyName == "frequency" || propertyName == "itemMls" || propertyName == "itemCals"){
			const number = parseFloat(value);
			if (!isNaN(number)) {
				const roundedNumber = Math.floor(number * 10) / 10;
				value = roundedNumber.toString();
			}
		}

		if (this.facilityOrderTemplateItems[index] && this.facilityOrderTemplateItems[index].id.includes('new')) {
			if (propertyName === "product") {
				this.facilityOrderTemplateItems[index]["procedureCode"] = value.procedureCode_ && value.procedureCode_.abrv;
			}
			this.facilityOrderTemplateItems[index][propertyName] = value;
		}
		else {
			const importActionInsert = this.importActions.find(x => x.abrv === 'insert');
			const importActionDelete = this.importActions.find(x => x.abrv === 'delete');

			if (this.facilityOrderTemplateItems[index]['importActionId'] === importActionInsert.id || this.facilityOrderTemplateItems[index]['importActionId'] === importActionDelete.id) {
				this.facilityOrderTemplateItems[index][propertyName] = value;
				this.facilityOrderTemplateItems[index]['changed'] = true;
			} else {
				const importActionUpdate = this.importActions.find(x => x.abrv === 'update');

				this.facilityOrderTemplateItems[index]['importActionId'] = importActionUpdate.id;
				this.facilityOrderTemplateItems[index]['importAction'] = importActionUpdate;
				this.facilityOrderTemplateItems[index][propertyName] = value;
				this.facilityOrderTemplateItems[index]['changed'] = true;
			}
		}
		if (!this.facilityOrderTemplate.notCurrent)
			this.updateSalesOrderQtyOnTemplateQtyChange(index, value, propertyName);

	}

	@action.bound
	async calculateQuantity(id, index, value, type) {
		const facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(this.rootStore.application.baasic.apiClient);
		if (value == null || value == undefined || value === "")
			value = 0;
		let response = null;
		if (type === 'itemMls') {
			response = await facilityOrderTemplateItemService.calculateQuantity({
				id: id,
				itemMls: value,
				itemCals: this.facilityOrderTemplateItems[index]['itemCals'],
				itemMlph: this.facilityOrderTemplateItems[index]['mlph'],
				frequency: this.facilityOrderTemplateItems[index]['frequency'],
				changedValue: 'itemMls'
			});
		}
		else if (type === 'itemCal') {
			response = await facilityOrderTemplateItemService.calculateQuantity({
				id: id,
				itemCals: value,
				itemMls: this.facilityOrderTemplateItems[index]['itemMls'],
				itemMlph: this.facilityOrderTemplateItems[index]['mlph'],
				frequency: this.facilityOrderTemplateItems[index]['frequency'],
				changedValue: 'itemCal'
			});
		}
		else if (type === 'itemMlph') {
			response = await facilityOrderTemplateItemService.calculateQuantity({
				id: id,
				itemCals: this.facilityOrderTemplateItems[index]['itemCals'],
				itemMls: this.facilityOrderTemplateItems[index]['itemMls'],
				itemMlph: value,
				frequency: this.facilityOrderTemplateItems[index]['frequency'],
				changedValue: 'itemMlph'
			});
		}
		else if (type === 'itemFrequency') {
			response = await facilityOrderTemplateItemService.calculateQuantity({
				id: id,
				itemCals: this.facilityOrderTemplateItems[index]['itemCals'],
				itemMls: this.facilityOrderTemplateItems[index]['itemMls'],
				itemMlph: this.facilityOrderTemplateItems[index]['mlph'],
				frequency: value,
				changedValue: 'itemFrequency'
			});
		}

		this.facilityOrderTemplateItems[index]['changed'] = true;
		this.facilityOrderTemplateItems[index]['orderQuantity'] = response.orderQuantity;
		this.facilityOrderTemplateItems[index]['templateQuantity'] = response.templateQuantity;
		this.facilityOrderTemplateItems[index]['billingQuantity'] = response.billingQuantity;
		this.facilityOrderTemplateItems[index]['templateBillingQuantity'] = response.templateBillingQuantity;
		this.facilityOrderTemplateItems[index]['itemCals'] = response.itemCals;
		this.facilityOrderTemplateItems[index]['itemMls'] = response.itemMls;
		this.facilityOrderTemplateItems[index]['mlph'] = response.mlph;
		this.facilityOrderTemplateItems[index]['frequency'] = response.frequency;
		this.formSubmit();
	}

	@action.bound
	formSubmit() {
		this.form.submit();
	}

	@action.bound
	updateSalesOrderQtyOnTemplateQtyChange(index, value, propertyName) {
		if (propertyName === 'templateQuantity' && value != 0) {
			this.facilityOrderTemplateItems[index]['orderQuantity'] = value;
			if(this.item.importReference && this.item.importReference.isBillableToMedicare === false){
				this.facilityOrderTemplateItems[index]['templateBillingQuantity'] = value;
			}
		}
		else if (propertyName === 'templateBillingQuantity' && this.facilityOrderTemplateItems[index]['orderQuantity'] == this.facilityOrderTemplateItems[index]['templateQuantity']) {
			this.facilityOrderTemplateItems[index]['billingQuantity'] = value;
		}
	}

	@action.bound
	addItem() {
		this.setProductStore();

		const importActionInsert = this.importActions.find(x => x.abrv == 'insert');

		const importDetailStatus = this.importDetailStatuses.find(x => x.abrv == 'new');

		this.facilityOrderTemplateItems.push({
			id: `new-${this.facilityOrderTemplateItems.length}`,
			product: null,
			productId: null,
			itemMlph: null,
			frequency: null,
			itemCals: 0,
			itemMls: 0,
			templateQuantity: this.item.subCategory.abrv === "Trach-Tube" || this.item.subCategory.abrv === "Urologicals" ? 1 : 0,
			orderQuantity: this.item.subCategory.abrv === "Trach-Tube" || this.item.subCategory.abrv === "Urologicals" ? 1 : 0,
			billingQuantity: 0,
			templateBillingQuantity: 0,
			facilityOrderTemplateId: this.item.id,
			importAction: importActionInsert && importActionInsert,
			importActionId: importActionInsert && importActionInsert.id,
			importDetailStatusId: importDetailStatus && importDetailStatus.id,
		});
	}

	@action.bound
	addNewItemToIndex(index) {
		this.setProductStore();

		const importActionInsert = this.importActions.find(x => x.abrv == 'insert');

		const importDetailStatus = this.importDetailStatuses.find(x => x.abrv == 'new');

		let list = this.facilityOrderTemplateItems.splice(index);

		this.facilityOrderTemplateItems.push({
			id: `new-${this.facilityOrderTemplateItems.length}`,
			product: null,
			productId: null,
			itemMlph: 0,
			frequency: 0,
			itemCals: 0,
			itemMls: 0,
			templateQuantity: 0,
			orderQuantity: 0,
			billingQuantity: 0,
			templateBillingQuantity: 0,
			facilityOrderTemplateId: this.item.id,
			importAction: importActionInsert && importActionInsert,
			importActionId: importActionInsert && importActionInsert.id,
			importDetailStatusId: importDetailStatus && importDetailStatus.id,
		});

		this.facilityOrderTemplateItems.push(...list);
	}

	@action.bound
	async saveItemOnProductSelect() {
		const deleteImportActionId = this.importActions.find(x => x.abrv == 'delete').id;
		if(this.facilityOrderTemplate.templateId && this.facilityOrderTemplate.subCategoryId === this.trachTubeSubCategoryId && this.facilityOrderTemplateItems.some(i => !i.id.startsWith('new') && i.importActionId !== deleteImportActionId)){
			this.rootStore.modalStore.showConfirm('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_DELTE_TRACH_TUBE_ITEMS', async () => { await this.saveItem(true); });
			return;
		}
		await this.missingDocumentStore.filterAsync();
		await this.saveItem();
	}

	@action.bound
	async saveItem(refreshTemplates = false) {
		try {
			await this.actions.batchCreateItems();

			if (this.templateContainsProcedureCode(PROCEDURE_CODE_B4035)){
				await this.validateFacilityOrderTemplate();
			}

			if(refreshTemplates){
				this.refreshTemplates(this.facilityOrderId, this.patientId)
			}
		}
		catch (err) {
			return this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
		}
	}

	@action.bound
	async updateFacilityOrderTemplateNotesActivity(facilityOrderTemplateNote) {
		try {
			var facilityOrderTemplateNoteService = new FacilityOrderTemplateNoteService(this.rootStore.application.baasic.apiClient);
			await facilityOrderTemplateNoteService.update({ id: facilityOrderTemplateNote.id, facilityOrderTemplateId: facilityOrderTemplateNote.facilityOrderTemplateId, note: facilityOrderTemplateNote.note, isActive: !facilityOrderTemplateNote.isActive });
			facilityOrderTemplateNote.isActive = !facilityOrderTemplateNote.isActive;
		}
		catch (err) {
			this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE.EDIT.UPDATE_PORTAL_NOTE_ERROR");
		}
	}

	// function for change items on template
	@action.bound
	async deleteAndAddItem(index, item, linkedTemplateId = null) {
		try {
			await this.deleteItem(index, item, linkedTemplateId);
			this.addNewItemToIndex(index);
		}
		catch (err) {
			this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
		}
	}

	// function for change items on template
	@action.bound
	setImportActionToDeleteAndAddItem(index, templateItemRowRef, item) {
		try {
			this.setImportActionToDelete(index, templateItemRowRef);
			if (item.importAction.name === "Delete") {
				this.addNewItemToIndex(index + 1);
			}
		}
		catch (err) {
			this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
		}
	}

	@action.bound
	async validateFacilityOrderTemplate() {
		var response = await this.service.validateFacilityOrderTemplate({ id: this.facilityOrderTemplate.id });
		this.facilityOrderTemplateValidations = response.data.facilityOrderTemplateValidations;
	}

	@action.bound
	async deleteItem(index, item, linkedTemplateId = null) {
		if (!item.id.startsWith("new") && item.importAction.name === "Insert") {

			try {
				await this.facilityOrderTemplateItemService.newDelete(item);
			} catch (ex) {
				if (ex && ex.data.includes("FK_InventoryCalculationCutback_FacilityOrderTemplateItem")) {
					this.rootStore.notificationStore.error("Template item cannot be deleted because it is included in the Inventory Calculation.");
				}
				else {
					this.rootStore.notificationStore.error("An unexpected error occurred while trying to delete the item.");
				}
				return;
			}

			if (item.product && item.product.innerCannulaId && this.trachItemCategoriesId === item.product.itemCategoryId) {
				this.removeFromFacilityOrderTemplateList(linkedTemplateId);
			}
		}

		this.facilityOrderTemplateItems.splice(index, 1);

		if (item.product && item.product.procedureCode === PROCEDURE_CODE_B4035)
			await this.validateFacilityOrderTemplate();

		if (this.facilityOrderTemplateItems.length === 0) {
			this.addItem();
		}
		else {
			var responseMessage = await this.service.validateItems(this.id, { embed: "FacilityOrderTemplateItems" });
			this.validationMessage = responseMessage.data;
		}
		await this.missingDocumentStore.filterAsync();
	}

	@action.bound
	setImportActionToDelete(index, templateItemRowRef) {
		const importActionDelete = this.importActions.find(x => x.abrv === 'delete');
		const importActionInsert = this.importActions.find(x => x.abrv === 'insert');
		const item = this.facilityOrderTemplateItems[index];

		if (item['importActionId'] === importActionInsert.id) {
			return;
		}

		if (item['importActionId'] === importActionDelete.id) {
			const importActionUpdate = this.importActions.find(x => x.abrv === 'update');

			item['importActionId'] = importActionUpdate.id;
			item['importAction'] = { ...importActionUpdate };
			item['changed'] = true;
			this.removeRowRedTextColor(templateItemRowRef);
		} else {
			item['importActionId'] = importActionDelete.id;
			item['importAction'] = { ...importActionDelete };
			item['changed'] = true;
			this.setRowTextColorToRed(templateItemRowRef);
		}
		this.form.submit();
		this.missingDocumentStore.filterAsync();
	}

	@action.bound
	async createTrackingCase(facilityOrderTemplate) {
		try {
			let response = await this.service.addTrackingCase(facilityOrderTemplate.id);
			this.item.trackingCase = response.data;

			this.rootStore.notificationStore.success("Created Case successfully.");
			window.open(this.rootStore.routerStore.findRoute('master.app.main.tracking-case.preview').pattern.replace(":id", response.data.id));
			this.checkIsReloadTemplateEnabled(this.item);
		}
		catch (err) {
			this.rootStore.notificationStore.error("Error occurred while trying to create a case.");
		}
	}

	@action.bound
	async showProductList() {
		try {
			let url = `${this.rootStore.routerStore.findRoute('master.app.main.product.list').pattern}?itemCategoryId=${this.item.itemCategory.id}`;
			window.open(`${url}`);
		}
		catch (err) {
			this.rootStore.notificationStore.error("Error occurred while trying to open products list.");
		}
	}

	@action.bound
	async importFacilityOrderTemplate(facilityOrderTemplateId) {
		var response = await this.service.isReviewedFacilityOrderAsync({ facilityOrderId: this.facilityOrderId });
		this.rootStore.modalStore.showConfirm(
			response.data ? 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_IMPORT' : 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_NOT_REVIEWED',
			async () => {
				try {
					await this.service.importFacilityOrderTemplate({ facilityOrderTemplateId: facilityOrderTemplateId });
					this.rootStore.notificationStore.success("Facility order template imported successfully.");
				}
				catch (err) {
					if (err.data && err.data.errors) {
						this.rootStore.notificationStore.error(err.data.errors);
					}
					else {
						this.rootStore.notificationStore.error("Error occurred while trying to import a facility order template.");
					}
				}
				await super.getResource(facilityOrderTemplateId);
			}
		);
	}

	@action.bound
	isEnteralTemplate() {
		return this.enteralItemCategories.some(i => i.id === this.item.subCategory.itemCategoryId);
	}

	@action.bound
	isUrologicalTemplate() {
		let urologicalCategory = this.itemCategories.find(i => i.abrv.includes("urological"));
		if(urologicalCategory){
			return this.item.subCategory.itemCategoryId === urologicalCategory.id;
		}
		return false;
	}

	@action.bound
	isWoundCareTemplate() {
		return this.woundCareItemCategories.some(i => i.id === this.item.subCategory.itemCategoryId);
	}

	@action.bound
	isMedicalNecessityFormCategory() {
		return this.itemCategories.some(i => i.id === this.item.subCategory.itemCategoryId && (i.abrv === 'respiratory' || i.abrv === 'ostomy' || i.abrv === 'urological' || 'enteral'));
	}

	@action.bound
	isStandardWrittenOrderCategory() {
		return this.itemCategories.some(i => i.id === this.item.subCategory.itemCategoryId && (i.abrv === 'respiratory' || i.abrv === 'ostomy' || i.abrv === 'urological' || 'enteral' || i.abrv === 'wound-care'));
	}
	isEnteralTemplateWithMissingCalories() {
		const itemTypeCanId = this.itemTypes.find(x => x.abrv === "can").id;
		const itemTypeBottleId = this.itemTypes.find(x => x.abrv === "bottle").id;
		return this.facilityOrderTemplateItems
			.some(x => (x.product && x.product.itemType && (x.product.itemTypeId === itemTypeCanId || x.product.itemTypeId === itemTypeBottleId)) &&
				(x.itemCals === 0 || x.itemCals === null || x.itemCals === undefined) && x.importActionId != this.importActions.find(y => y.abrv === 'delete').id);
	}

	getMissingInformationUrological() {
		return this.facilityOrderTemplateItems.some(x =>
			(
				(x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4352")) ||
				(x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4353")) ||
				(x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4351"))
			) &&
			((!x.templateQuantity) || (x.templateQuantity == 0) || (x.templateQuantity % 28 != 0))
		);
	}
	
	getMissingInformationText(){
        let isPatientWeightMissing = this.btPatient && !this.btPatient.weight;
        let isPatientHeightMissing = this.btPatient && !this.btPatient.height;
        let isCalorieAmountMissing = this.isEnteralTemplateWithMissingCalories();
        let isPatientGenderMissing = this.btPatient && !this.btPatient.gender;
        let isMlphMissing = this.facilityOrderTemplateItems.some(x => x.product && x.product.itemTypeId && !x.mlph && x.importActionId != this.importActions.find(y => y.abrv == 'delete').id);
    
        let missingItems = [];
        if (isPatientWeightMissing) {
            missingItems.push("weight");
        }
        if (isPatientHeightMissing) {
            missingItems.push("height");
        }
        if (isCalorieAmountMissing) {
            missingItems.push("total calories");
        }
        if (isPatientGenderMissing) {
            missingItems.push("gender");
        }
        if (isMlphMissing) {
            missingItems.push("flow rate");
        }
		missingItems.sort();

        if (missingItems.length > 0)
			return missingItems;
        return null;
    }

	@action.bound
	async generateMedicalNecessityForm(id) {
		try {
			await this.saveAllTemplates();
			if (this.isEnteralTemplate() && this.getMissingInformationText()) {
				this.facilityOrderTemplatePNMissingInformationModal.open({
					missingInformation: this.getMissingInformationText(),
					generateMedicalNecessityForm: () => this.openMedicalNecessityWindow(id)
				});
			} 
			else if(this.isUrologicalTemplate() && this.getMissingInformationUrological()){
				this.facilityOrderTemplatePNMissingInformationModal.open({
					missingInformation: ["Qty per day (system cannot determine)"],
					generateMedicalNecessityForm: () => this.openMedicalNecessityWindow(id)
				});
			}
			else {
				this.openMedicalNecessityWindow(id);
			}
		}
		catch (err) {
			this.rootStore.notificationStore.error("Error occurred while trying to generate Medical Necessity Form.");
		}
	}

	@action.bound
	async openMedicalNecessityWindow(id) {
		var url = `${this.service.getMedicalNecessityFormReportUrl(id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
		window.open(url, "_blank")
		this.rootStore.notificationStore.success("Progress Notes document successfully generated.");
	}

	@action.bound
	async generateStandardWrittenOrder(id) {
		try {
			this.saveAllTemplates();
			var url = `${this.service.getStandardWrittenOrderReportUrl(id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
			window.open(url, "_blank")
			this.rootStore.notificationStore.success("Standard Written Order successfully generated.");
		}
		catch (err) {
			this.rootStore.notificationStore.error("Error occurred while trying to generate Standard Written Order.");
		}
	}
	@action.bound
	checkIsReloadTemplateEnabled(item) {
		this.isFacilityInventoryCountHeaderCreated = item.facilityOrder && item.facilityOrder.facilityInventoryCountHeaderId !== null;
		this.isReloadTemplateEnabled = item && item.templateId !== null && item.importDetailStatus && item.importDetailStatus.abrv === 'new' && item.trackingCase === null;
	}

	@action.bound
	reloadFacilityOrderTemplate() {

		var message = 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD';
		if (this.isFacilityInventoryCountHeaderCreated) {
			message = 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD_INVENTORY_COUNT';
			if (this.facilityInventoryCalculation) {
				message = this.facilityInventoryCalculation.isDone ? 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD_INVENTORY_COUNT_PROCESSED_INVENTORY_CALCULATION' : 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD_INVENTORY_COUNT_NON_PROCESSED_INVENTORY_CALCULATION';
			}
		}
		this.rootStore.modalStore.showConfirm(
			message,
			async () => {
				try {
					await this.service.reloadFacilityOrderTemplate({ id: this.item.id });
					this.rootStore.notificationStore.success('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD_SUCCESS');
				}
				catch (err) {
					if (err.data && err.data.errors) {
						this.rootStore.notificationStore.error(err.data.errors);
					}
					else {
						this.rootStore.notificationStore.error('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_RELOAD_ERROR');
					}
				}
				this.refreshTemplates(this.facilityOrderId, this.patientId);
			}
		);
	}

	@action.bound
	checkMatchReference(insuranceInfo, isBillableToMedicare) {
		if (isBillableToMedicare) {
			this.isMatchReference = this.primaryInsuranceInfo == insuranceInfo;
		}
		else {
			this.isMatchReference = true;
		}
	}

	@action.bound
	isNewTemplate() {
		return this.item && this.item.templateId === null;
	}

	@action.bound
	isImportActionDelete(index) {
		const importActionDelete = this.importActions.find(x => x.abrv === 'delete');

		return this.facilityOrderTemplateItems[index].importActionId === importActionDelete.id;
	}

	@action.bound
	isNewItem(index) {
		return this.facilityOrderTemplateItems[index].id.includes("new");
	}

	cloneObjectAndAttachProps(objToClone, props) {
		if (objToClone && props) {
			return { ...objToClone, ...props };
		}

		return {};
	}

	@action.bound
	setRowImportActionStatusColor() {
		if (this.facilityOrderTemplateItems) {
			this.facilityOrderTemplateItems.forEach((item, index) => {
				if (this.isImportActionDelete(index)) {
					this.setRowTextColorToRed(this.templateItemsRowRefs[index]);
				}
			})
		}
	}

	removeEffectFromEditedCells() {
		const editedCells = document.querySelectorAll("td.edited");

		if (editedCells.length > 0) {
			editedCells.forEach((cell) => {
				cell.style.backgroundColor = cell.previousSibling.style.backgroundColor;
				cell.classList.remove("edited");
			});
		}
	}

	setRowTextColorToRed(templateItemRowRef) {
		if (templateItemRowRef) {
			templateItemRowRef.classList.add('table--warning');
		}
	}

	removeRowRedTextColor(templateItemRowRef) {
		if (templateItemRowRef) {
			templateItemRowRef.classList.remove('table--warning');
		}
	}

	@action.bound
	async saveTemplateAndItems(saveReviewed, validateTemplate = true) {
		try {
			const response = await this.actions.updateTemplateAndItems({
				id: this.id,
				...this.form.values(),
				isReviewed: saveReviewed ? true : this.form.values().isReviewed
			});

			if (this.isNoneInactiveReason && validateTemplate && saveReviewed && this.facilityOrderTemplateValidations.some(x => !x.isResolved)) {
				this.rootStore.notificationStore.error("Template can't be reviewed because of the existing validation(s).");
			}

			this.item.isReviewed = response.isReviewed;
			if (saveReviewed && response.isReviewed) {
				await this.checkIsTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility();
			}
			this.form.$('isReviewed').value = response.isReviewed;

			this.item.branchId = response.branchId;
			this.form.$('branchId').value = response.branchId;

			this.item.inactiveReasonId = response.inactiveReasonId;
			this.form.$('inactiveReasonId').value = response.inactiveReasonId || response.inactiveReasonId === 0 ? response.inactiveReasonId.toString() : null;

			this.lastValidated += 2;
			this.removeEffectFromEditedCells();
		}
		catch (err) {
			let errorMessage = typeof err.data === "object" ? err.data.errorMessage : err.data;
			this.rootStore.notificationStore.error(errorMessage ? errorMessage : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
		}
	}

	@action.bound
	async isTemplateValidatedToReview() {
		if (this.isNoneInactiveReason && !this.isMatchReference || (this.isTemplateBillableToMedicare() && this.form.$("secondaryInsuranceVerified").value === "")) {
			return false;
		}
		return true;
	}

	@action.bound
	async checkIsTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility() {
		var response = await this.service.isTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility({ facilityOrderId: this.item.facilityOrderId, itemCategoryId: this.item.subCategory.itemCategoryId });
		if (response.data) {
			this.rootStore.notificationStore.error("Template is linked with an Area of Care whose Coverage Type on the Facility is Don't Supply.");
		}
	}

	@action.bound
	async saveOnReviewed(e) {
		//without e.validated part of if statement, there would be infinite loop
		if (e.value === true && e.changed === true && (e.validated - this.lastValidated == 2 || e.validated - this.lastValidated == 1)) {
			this.lastValidated += 2;
			await this.updateTemplateAndItemsResource(this.form.values());
			if (this.isNoneInactiveReason && this.facilityOrderTemplateValidations.some(x => !x.isResolved)) {
				this.rootStore.notificationStore.error("Template can't be reviewed because of the existing validation(s).");
			} else {
				await this.checkIsTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility();
			}
		}
	}

	@action.bound
	isTemplateBillableToMedicare() {
		return this.item.importReference && this.item.importReference.isBillableToMedicare === true;
	}

	@action.bound
	templateContainsCanItem() {
		const itemTypeCanId = this.itemTypes
			.find(x => x.abrv === "can").id;

		return this.facilityOrderTemplateItems
			.some(x => x.product && x.product.itemType && x.product.itemTypeId === itemTypeCanId);
	}

	@action.bound
	templateContainsBottleItem() {
		const itemTypeBottleId = this.itemTypes
			.find(x => x.abrv === "bottle").id;

		return this.facilityOrderTemplateItems
			.some(x => x.product && x.product.itemType && x.product.itemTypeId === itemTypeBottleId);
	}

	@action.bound
	templateContainsFeedingBagItem() {
		return this.facilityOrderTemplateItems
			.some(x => x.product && x.product.description.toLowerCase().includes("feeding bag"));
	}

	@action.bound
	templateContainsEnteralSupItem() {
		return this.facilityOrderTemplateItems
			.some(x => x.product && x.product.procedureCode === PROCEDURE_CODE_B4035 || x.product && x.product.procedureCode === PROCEDURE_CODE_B4036);
	}

	@action.bound
	templateContainsProcedureCode(procedureCode) {
		return this.facilityOrderTemplateItems
			.some(x => x.product && x.product.procedureCode === procedureCode);
	}

	@action.bound
	async updateTemplateAndItemsResource(resource) {
		this.form.setFieldsDisabled(true);
		try {
			if (this.translationStore) {
				this.translationStore.applyMetadata(resource);
			}

			this.validationMessage = '';

			await this.actions.updateTemplateAndItems({
				id: this.id,
				...resource
			});

			const response = await this.service.get(this.id, { embed: "ImportReference,FacilityOrderTemplateMissingDocuments" });

			this.setFacilityOrderTemplateMissingDocumentId(response.data.facilityOrderTemplateMissingDocuments);

			this.form.$('isReviewed').value = response.data.isReviewed;
			this.item.branchId = response.data.branchId;
			this.form.$('branchId').value = response.data.branchId;

			this.item.inactiveReasonId = response.data.inactiveReasonId;
			this.form.$('inactiveReasonId').value = response.data.inactiveReasonId || response.data.inactiveReasonId === 0 ? response.data.inactiveReasonId.toString() : null;

			if (response.data.inactiveReasonId === 0) {
				this.isNoneInactiveReason = true;
			} else {
				this.isNoneInactiveReason = false;
			}

			this.item.importReference = response.data.importReference;
			this.item.importReferenceId = response.data.importReferenceId;

			this.isNotFoundImportReference = response.data.importReference && response.data.importReference.abrv === 'not-found' ? true : false;

			await this.isReadyForImportFacilityOrder();

			this.form.setFieldsDisabled(false);
			this.removeEffectFromEditedCells();
		}
		catch (err) {
			this.form.setFieldsDisabled(false);

			let errorMessage = typeof err.data === "object" ? err.data.errorMessage : err.data;
			this.rootStore.notificationStore.error(errorMessage ? errorMessage : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
		}
		clearTimeout(this.timer);
	}

	@action.bound
	async updateResource(resource) {
		if(!this.isQtyReadOnly){
			this.isQtyReadOnly = true;
			await this.updateTemplateAndItemsResource(resource);
			this.isDirty = false;
			this.isQtyReadOnly = false;
		}
	}
	@action.bound
	setFacilityOrderTemplateMissingDocumentId(facilityOrderTemplateMissingDocuments) {
		for (let missingDocument of this.form.$("facilityOrderTemplateMissingDocuments").value) {
			if (missingDocument.facilityOrderTemplateMissingDocumentId === undefined) {
				const id = facilityOrderTemplateMissingDocuments.find(i => i.missingDocumentId === missingDocument.id).id;
				missingDocument = _.extend(missingDocument, { facilityOrderTemplateMissingDocumentId: id });
			}
		}
	}

	@action.bound
	renderValidationsTitle(facilityOrderTemplateValidations) {
		let validationMessages = [];
		validationMessages.push("Failed Validations: \n");

		facilityOrderTemplateValidations.forEach(itemValidation => {
			if (itemValidation.isResolved === false)
				validationMessages.push(`${itemValidation.notes} \n`);
		});
		return validationMessages.join("");
	}

	@action.bound
	goToTrackingCase(trackingCase) {
		let url = this.rootStore.routerStore.findRoute('master.app.main.tracking-case.preview').pattern;
		url = url.replace(":id", trackingCase.id);
		window.open(`${url}`);
	}
}

export default FacilityOrderTemplateItemEditViewStore;